export default (httpClient) => ({
  save: async ({ tarefa, token }) => {
    const headers = {
      Authorization: "Bearer " + token,
      Accept: "application/json",
    };
    const response = await httpClient.post("/atribuir-tarefa", tarefa, {
      headers,
    });
    return {
      data: response.data,
    };
  },

  delete: async ({ id, token }) => {
    const headers = {
      Authorization: "Bearer " + token,
      Accept: "application/json",
    };
    const response = await httpClient.delete(`/tarefas/${id}`, {
      headers,
    });
    return {
      data: response.data,
    };
  },

  update: async ({ id, tarefa, token }) => {
    const headers = {
      Authorization: "Bearer " + token,
      Accept: "application/json",
    };
    const response = await httpClient.put(`/tarefas/${id}`, tarefa, {
      headers,
    });
    return {
      data: response.data,
    };
  },

  getAll: async ({ token }) => {
    const headers = {
      Authorization: "Bearer " + token,
      Accept: "application/json",
    };
    const response = await httpClient.get("/colaboradores-tarefas", {
      headers,
    });
    return {
      data: response.data,
    };
  },

  getById: async ({ id, token }) => {
    const headers = {
      Authorization: "Bearer " + token,
      Accept: "application/json",
    };
    const response = await httpClient.get(`/colaboradores-tarefas/${id}`, {
      headers,
    });
    return {
      data: response.data,
    };
  },

  tarefasHoje: async ({ id, token }) => {
    const headers = {
      Authorization: "Bearer " + token,
      Accept: "application/json",
    };
    const response = await httpClient.get('/tarefas-do-dia-admin', {
      headers,
    });
    return {
      data: response.data,
    };
  },

  postById: async ({ id, token, status }) => {
    const headers = {
      Authorization: "Bearer " + token,
      Accept: "application/json",
    };

    const body = { status };

    const response = await httpClient.post(`/alterar-status-tarefa-adm/${id}`, body, { headers });
    return {
      data: response.data,
    };
  },

  tarefasPorDataColaborador: async ({ colaboradorId, dataSelecionada, token }) => {
    const headers = {
      Authorization: "Bearer " + token,
      Accept: "application/json",
    };
    const response = await httpClient.post(
      "/tarefas-por-data-colaborador",
      { colaborador_id: colaboradorId, data_criacao: dataSelecionada },
      { headers }
    );
    return {
      data: response.data,
    };
  },
});
